export const ngDeps = {};

export function injectNgDeps(config)
{
    Object.assign(ngDeps, config);
}

window.injectNgDeps = injectNgDeps;

export default ngDeps;
